export enum SPORT_GROUPS {
  TOP_EVENTS = 'topEvents',
}
